import * as common from '../common/Common';
import { appService } from '../common/AppService';

export class SignInViewModel {
    public username: string='';
    public password: string='';
    public error = '';

    public submit() {
        if (!this.username || !this.password) {
            this.error = 'Please fill all the information.';
        } else {
            common.callHttp('POST', 'user/signin', {
                Username: this.username,
                Password: this.password
            }).then((data) => {
                common.setLongCookie('authtoken', data);
                Promise.all([appService.getUserModel()]).then(() => {
                    appService.navigateTo('home');
                }, error => {
                    appService.navigateTo('home');
                });

                appService.requestDeviceToken();
            }, error => {
                this.username = '';
                this.password = '';
                this.error = error.ExceptionMessage || 'Wrong username or password.';                
            });
        }
    }
}